import React from 'react';

export default function RakutenFeeNote() {
  return (
    <div className="alert alert-info">
      出店プラン・月商レンジ・平均バスケット単価の設定をもとに、システム利用料などの手数料が自動計算されます。
      <br />
      料金の詳細は
      <a href="https://www.rakuten.co.jp/ec/plan/cost_detail/" target="_blank" rel="noopener noreferrer" className="ms-1">
        楽天市場 出店プラン・費用（外部サイト）
      </a>
      をご参照ください。
    </div>
  );
}
